import React, { Component } from 'react';
import PropTypes from 'prop-types';

import GrayPanel from '../../components/GrayPanel';
import ModalAlert from '../../components/ModalAlert';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';
import { runService } from '../../actions/eservices';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import pans from './panStyle.scss';


import Select from 'react-select';
import { throws } from 'assert';
import v from './validators';

class InvestContact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name_investor: null,
      form_cooperation: null,
      form_other: null,
      nip: null,
      regon: null,
      krs: null,
      address: null,
      pageWWW: null,
      name: null,
      function: null,
      name_contact: null,
      function_contact: null,
      phone: null,
      fax: null,
      email_contact: null,
      year_start: null,
      main_products: null,
      description_invest: null,
      plan_innovations: null,
      pkwiu: null,
      plot: null,
      area_build: null,
      electricity: null,
      gas: null,
      water: null,
      network: null,
      przejecie_nieruchomosci: null,
      planned_capital: null,
      planned_buy_plot: null,
      start: null,
      end: null,
      amount_employees: null,
      special: null,
      additional: null,
      start_year: null,
      export: null,
      where_export: null,
      teryt: null,

      errors: {},
      errorTitle: '',
      errorText: '',
      showError: false,
    };

    this.validators = {
      name_investor: [v.NotNull],
      form_cooperation: [v.NotSelected],
      nip: [v.NotNull, v.CheckNIP],
      regon: [v.NotNull, v.CheckREGON],
      address: [v.NotNull],
      name: [v.NotNull],
      function: [v.NotNull],
      start_year: [v.NotNull, v.isStrictInteger],
      krs: [v.isStrictInteger],
      main_products: [v.NotNull],
      name_contact: [v.NotNull],
      function_contact: [v.NotNull],
      phone: [v.NotNull, v.isNumber],
      email_contact: [v.NotNull, v.CheckEmail],
      description_invest: [v.NotNull],
      pkwiu: [v.NotNull],
      plot: [v.NotNull, v.isNumber],
      area_build: [v.NotNull, v.isNumber],
      gas: [v.NotNull, v.isNumber],
      electricity: [v.NotNull, v.isNumber],
      water: [v.NotNull, v.isNumber],
      network: [v.NotNull, v.isStrictInteger],

      przejecie_nieruchomosci: [v.NotSelected],
      planned_capital: [v.NotNull, v.isNumber],
      planned_buy_plot: [v.NotNull],
      start: [v.NotNull],
      end: [v.NotNull],
      amount_employees: [v.NotNull, v.isStrictInteger],
      export: [v.NotSelected, v.NotNull],
      form_other: [v.NotNull],
      where_export: [v.NotNull],
      special: [v.NotSelected],
    };

    this.nextStep = '/eservices/eserviceSummary/';

    this.errorSpanStyle = {
      color: 'red',
      fontSize: '10px',
    };
  }



  componentDidMount() {
    // Pobieram teryt z linku i przypisuje do state
    const url_string = window.location.href;
    const url = new URL(url_string);
    const c = url.searchParams.get('district');

    this.setState({
      teryt: c,
    });
  }

  insertTestData = () => {
    this.setState({
      name_investor: 'test investor',
      form_cooperation: 'Spółka cywilna',
      form_other: 'form other',
      nip: '9566811797',
      regon: '677503917',
      address: 'varszawa',
      name: 'Inwestycja Kopiec Fila',
      function: 'rozrywka',
      name_contact: 'Krzysztof Gregorowicz',
      function_contact: 'Programista',
      phone: '787214929',
      email_contact: 'gregorowicz.k@gmail.com',
      year_start: 2005,
      main_products: 'jakis przediomt',
      description_invest: 'to jest bardzo ciekawy opis investycji',
      plan_innovations: 'plan inovationssssssssss',
      pkwiu: '29.97 Z',
      // plot: 551321,
      area_build: 13532,
      przejecie_nieruchomosci: 'Własność',
      planned_capital: 23335,
      planned_buy_plot: 'planned buy plot',
      start: '1992',
      end: '1992',
      special: 'Tak',
      start_year: 2020,
      amount_employees: 123,
      // main_products: 'seriously main prods ?',
      export: 'Nie',
      where_export: 'nibylandia',
    });
  };

  newLabel = (label) => {
    return { __html: label }
  }

  handleChangeSelect = (e, name) => {
    this.setState({
      [name]: e.value,
    },
      () => this.validate(name),
    );
    if (name == 'export') {
      if(e.value == 'Tak') {
        this.validators.where_export = [v.NotNull];
      } else {
        this.validators.where_export = [];
      }
    }
    if (name == 'form_cooperation') {
      if(e.value == 'Inna') {
        this.validators.form_other = [v.NotNull];
      } else {
        this.validators.form_other = [];
      }
    }
  };

  htmlDecode(input) {
    if (typeof window !== 'undefined') {
      var e = document.createElement('div');
      e.innerHTML = input;
      return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }
  }

  handleChange = (e, name) => {
    this.setState({
      [name]: e.target.value,
    },
      () => this.validate(name),
    );
  };

  validateField = (field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validate = (field, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(field);

        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    }
    else {
      let errors = { ...this.state.errors };
      for (const field of Object.keys(this.validators)) {
        const checks = this.validateField(field);
        errors = { ...errors, [field]: checks };
      }
      newState = {
        errors: {
          ...errors
        },
      };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  onHide = () => this.setState({ showError: false });

  runService = () => {

    const data = {
      service_data: {
        inwestor: this.state.name_investor,
        prawna_forma: this.state.form_cooperation,
        nip: this.state.nip,
        regon: this.state.regon,
        krs: this.state.krs,
        www: this.state.pageWWW,
        name: this.state.name,
        function: this.state.function,
        name_contact: this.state.name_contact,
        function_contact: this.state.function_contact,
        phone: this.state.phone,
        email: this.state.email_contact,
        fax: this.state.fax,
        description: this.state.description_invest,
        plan_innovations: this.state.plan_innovations,
        pkwiu: this.state.pkwiu,
        plot: this.state.plot,
        area_build: this.state.area_build,
        eletricity: this.state.electricity ? this.state.electricity : null,
        gas: this.state.gas ? this.state.gas : null,
        water: this.state.water ? this.state.water : null,
        network: this.state.network ? this.state.network : null,
        przejecie_nieruchomosci: this.state.przejecie_nieruchomosci,
        planned_capital: this.state.planned_capital,
        planned_buy_plot: this.state.planned_buy_plot,
        planned_innovations: this.state.plan_innovations,
        start: this.state.start,
        end: this.state.end,
        amount_employees: this.state.amount_employees,
        special: this.state.special,
        additional: this.state.additional,
        start_year: this.state.start_year,
        main_products: this.state.main_products,
        export: this.state.export,
        where_export: this.state.where_export,
        address: this.state.address,
        teryt: this.state.teryt,
        form_other: this.state.form_other,
        fk_userID: this.props.serviceInfo.user.ID,
        short_name: 'invest_contact',
      },
      user: { ...this.props.serviceInfo.user },
      urzad: this.props.districts[this.props.prefix],
    };


    const url = `${process.env.API_URL}/invest/create_topic`;
    // let url = 'http://localhost:8000/api/v1.0/invest/create_topic';
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, */*',
      },
      body: JSON.stringify(data),
    })
      .then(r => r.json())
      .then(resp => {
        window.location.href = `${this.nextStep}${resp.jobId}`;
      })
      .catch(resp => {
        this.onJobFailed();
      });
  };

  onJobFailed = () => this.setState({
    isWorking: false,
    errorText: 'Wystąpił błąd po stronie serwera. Administrator portalu został poinformowany o zaistniałej sytuacji.',
    errorTitle: 'Tymczasowa niedostępność usługi.',
    showError: true,
  });

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Formularz zawiera błędy.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true
      });
      return;
    }

    if (!hasFieldErrors) {
      this.runService()
    }
  }

  startService = () => {
    this.validate(null, this.postValidation);
  };

  getStandartInputErrorStyle = (name_state) => {
    const standardInputErrStyle = {
      width: '100%',
      ...this.getSelectErrorStyle(name_state)
    };
    return standardInputErrStyle;
  }

  getSelectErrorStyle = (name_state) => {
    const selectErrorStyle = {
      borderColor:
        Object.keys(this.state.errors).indexOf(name_state) > -1 &&
          this.state.errors[name_state] !== null &&
          this.state.errors[name_state].length > 0
          ? 'red'
          : '#ccc',
    };
    return selectErrorStyle;
  }

  renderErrorsInSpan = (name_state) => {
    if (Object.keys(this.state.errors).indexOf(name_state) > -1 &&
      this.state.errors[name_state] !== null &&
      this.state.errors[name_state].length > 0) {
      const span = this.state.errors[name_state].map((val, index) => (
        <span key={index} style={this.errorSpanStyle}>
          {val}
        </span>
      ))
      return span;
    } else return null;
  }

  render() {
    // layout classes
    const labelCol = 'col-sm-2';
    const inputCol = 'col-sm-7';

    // really simple styles
    const labelStyle = { marginTop: '.5rem' };
    const rowStyle = { marginTop: '15px' };

    // Forma prawna
    const formaPrawna = [
      {
        label: 'Osoba fizyczna prowadząca działalność gospodarczą',
        value: 'Osoba fizyczna prowadząca działalność gospodarczą',
      },
      {
        label: 'Spółka cywilna',
        value: 'Spółka cywilna',
      },
      {
        label: 'Spółka jawna',
        value: 'Spółka jawna',
      },
      {
        label: 'Spółka z ograniczoną odpowiedzialnością',
        value: 'Spółka z ograniczoną odpowiedzialnością',
      },
      {
        label: 'Spółka akcyjna',
        value: 'Spółka akcyjna',
      },
      {
        label: 'Inna (wpisz na dole sekcji Dane inwestora)',
        value: 'Inna',
      },
    ];

    const optionsPrzejecia = [
      {
        label: 'Własność',
        value: 'Własność',
      },
      {
        label: 'Użytkowanie wieczyste',
        value: 'Użytkowanie wieczyste',
      },
      {
        label: 'Najem',
        value: 'Najem',
      },
    ];

    const yesOrNo = [
      {
        label: 'Nie',
        value: 'Nie',
      },
      {
        label: 'Tak',
        value: 'Tak',
      },
    ];

    const whereExport = [
      {
        label: 'Nie',
        value: 'Nie',
      },
      {
        label: 'Tak, dokąd? (wpisz na dole sekcji Dane inwestora)',
        value: 'Tak',
      },
    ];

    // dane inwestora
    this.optionsInvestor = [
      {
        label: 'Nazwa inwestora', // Nazwa wyświetlana
        state: this.state.name_investor, // Jaki state bedzie trzymal dane
        name_state: 'name_investor', // Nazwa state'a zeby zmieniac
        placeholder: 'Nazwa inwestora...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Forma prawna działalności',
        state: this.state.form_cooperation,
        name_state: 'form_cooperation',
        placeholder: 'Forma prawna działalności',
        type_input: 1, // 0 - zwykly input, 1 - Select
        options: formaPrawna, // Tablica z wyborami,
      },
      {
        label: 'NIP', // Nazwa wyświetlana
        state: this.state.nip, // Jaki state bedzie trzymal dane
        name_state: 'nip', // Nazwa state'a zeby zmieniac
        placeholder: 'NIP...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'REGON', // Nazwa wyświetlana
        state: this.state.regon, // Jaki state bedzie trzymal dane
        name_state: 'regon', // Nazwa state'a zeby zmieniac
        placeholder: 'REGON...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Numer KRS (opcjonalnie)', // Nazwa wyświetlana
        state: this.state.krs, // Jaki state bedzie trzymal dane
        name_state: 'krs', // Nazwa state'a zeby zmieniac
        placeholder: 'Numer KRS...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Adres', // Nazwa wyświetlana
        state: this.state.address, // Jaki state bedzie trzymal dane
        name_state: 'address', // Nazwa state'a zeby zmieniac
        placeholder: 'Adres...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Strona WWW (opcjonalnie)', // Nazwa wyświetlana
        state: this.state.pageWWW, // Jaki state bedzie trzymal dane
        name_state: 'pageWWW', // Nazwa state'a zeby zmieniac
        placeholder: 'Strona WWW...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Imię i nazwisko osoby uprawnionej do reprezentowania inwestora', // Nazwa wyświetlana
        state: this.state.name, // Jaki state bedzie trzymal dane
        name_state: 'name', // Nazwa state'a zeby zmieniac
        placeholder: 'Imię i nazwisko osoby uprawnionej do reprezentowania inwestora...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Funkcja osoby uprawnionej do reprezentowania inwestora', // Nazwa wyświetlana
        state: this.state.function, // Jaki state bedzie trzymal dane
        name_state: 'function', // Nazwa state'a zeby zmieniac
        placeholder: 'Funkcja osoby uprawnionej do reprezentowania inwestora...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Rok rozpoczęcia działalności', // Nazwa wyświetlana
        state: this.state.start_year, // Jaki state bedzie trzymal dane
        name_state: 'start_year', // Nazwa state'a zeby zmieniac
        placeholder: 'Rok rozpoczęcia działalności...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Główne produkty lub usługi', // Nazwa wyświetlana
        state: this.state.main_products, // Jaki state bedzie trzymal dane
        name_state: 'main_products', // Nazwa state'a zeby zmieniac
        placeholder: 'Główne produkty lub usługi...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Czy firma eksportuje swoje produkty/usługi', // Nazwa wyświetlana
        state: this.state.export, // Jaki state bedzie trzymal dane
        name_state: 'export', // Nazwa state'a zeby zmieniac
        placeholder: 'Czy firma eksportuje swoje produkty/usługi...',
        type_input: 1, // 0 - zwykly input, 1 - React Select
        options: whereExport, // Tablica z wyborami,
      },
    ];

    // Pola z danymi kontaktowymi
    this.dataContact = [
      {
        label: 'Imię i nazwisko', // Nazwa wyświetlana
        state: this.state.name_contact, // Jaki state bedzie trzymal dane
        name_state: 'name_contact', // Nazwa state'a zeby zmieniac
        placeholder: 'Imię i nazwisko...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami
      },
      {
        label: 'Funkcja', // Nazwa wyświetlana
        state: this.state.function_contact, // Jaki state bedzie trzymal dane
        name_state: 'function_contact', // Nazwa state'a zeby zmieniac
        placeholder: 'Funkcja...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami
      },
      {
        label: 'Numer telefonu', // Nazwa wyświetlana
        state: this.state.phone, // Jaki state bedzie trzymal dane
        name_state: 'phone', // Nazwa state'a zeby zmieniac
        placeholder: 'Numer telefonu...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami
      },
      {
        label: 'FAX (opcjonalnie)', // Nazwa wyświetlana
        state: this.state.fax, // Jaki state bedzie trzymal dane
        name_state: 'fax', // Nazwa state'a zeby zmieniac
        placeholder: 'FAX...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami
      },
      {
        label: 'E-mail', // Nazwa wyświetlana
        state: this.state.email_contact, // Jaki state bedzie trzymal dane
        name_state: 'email_contact', // Nazwa state'a zeby zmieniac
        placeholder: 'E-mail...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami
      },
    ];

    // Dane inwestycji
    this.optionsInvest = [
      {
        label: 'Krótki opis przedsięwzięcia', // Nazwa wyświetlana
        state: this.state.description_invest, // Jaki state bedzie trzymal dane
        name_state: 'description_invest', // Nazwa state'a zeby zmieniac
        placeholder: 'Krótki opis przedsięwzięcia...',
        type_input: 2, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Planowane do wdrożenia innowacje (jeżeli dotyczy)', // Nazwa wyświetlana
        state: this.state.plan_innovations, // Jaki state bedzie trzymal dane
        name_state: 'plan_innovations', // Nazwa state'a zeby zmieniac
        placeholder: 'Planowane do wdrożenia innowacje (jeżeli dotyczy)...',
        type_input: 2, // 0 - zwykly input, 1 - React Select, 2 - Textarea
      },
      {
        label: 'Przedmiot planowanej działalności według PKWiU', // Nazwa wyświetlana
        state: this.state.pkwiu, // Jaki state bedzie trzymal dane
        name_state: 'pkwiu', // Nazwa state'a zeby zmieniac
        placeholder: 'Przedmiot planowanej działalności według PKWiU...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Powierzchnia terenu niezbędna do realizacji inwestycji [ha]', // Nazwa wyświetlana
        state: this.state.plot, // Jaki state bedzie trzymal dane
        name_state: 'plot', // Nazwa state'a zeby zmieniac
        placeholder: 'Powierzchnia terenu niezbędna do realizacji inwestycji [ha]...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Powierzchnia budynku/budynków [m&lt;sup&gt;2&lt;/sup&gt;]', // Nazwa wyświetlana
        state: this.state.area_build, // Jaki state bedzie trzymal dane
        name_state: 'area_build', // Nazwa state'a zeby zmieniac
        placeholder: 'Powierzchnia budynku/budynków...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
        index_up: true
      },
      {
        label: 'Orientacyjne zapotrzebowanie: gaz [m&lt;sup&gt;3&lt;/sup&gt;/h]', // Nazwa wyświetlana
        state: this.state.gas, // Jaki state bedzie trzymal dane
        name_state: 'gas', // Nazwa state'a zeby zmieniac
        placeholder: 'Orientacyjne zapotrzebowanie: gaz...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Orientacyjne zapotrzebowanie: energia elektryczna [kW]', // Nazwa wyświetlana
        state: this.state.electricity, // Jaki state bedzie trzymal dane
        name_state: 'electricity', // Nazwa state'a zeby zmieniac
        placeholder: 'Orientacyjne zapotrzebowanie: energia elektryczna [kW]...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Orientacyjne zapotrzebowanie: woda [m&lt;sup&gt;3&lt;/sup&gt;/h]', // Nazwa wyświetlana
        state: this.state.water, // Jaki state bedzie trzymal dane
        name_state: 'water', // Nazwa state'a zeby zmieniac
        placeholder: 'Orientacyjne zapotrzebowanie: woda...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Orientacyjne zapotrzebowanie: sieć teletechniczna [linii]', // Nazwa wyświetlana
        state: this.state.network, // Jaki state bedzie trzymal dane
        name_state: 'network', // Nazwa state'a zeby zmieniac
        placeholder: 'Orientacyjne zapotrzebowanie: sieć teletechniczna [linii]...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Forma nabycia nieruchomości', // Nazwa wyświetlana
        state: this.state.przejecie_nieruchomosci, // Jaki state bedzie trzymal dane
        name_state: 'przejecie_nieruchomosci', // Nazwa state'a zeby zmieniac
        placeholder: 'Forma nabycia nieruchomości...',
        type_input: 1, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: optionsPrzejecia, // Tablica z wyborami
      },
      {
        label: 'Wartość planowanych nakładów inwestycyjnych [PLN]', // Nazwa wyświetlana
        state: this.state.planned_capital, // Jaki state bedzie trzymal dane
        name_state: 'planned_capital', // Nazwa state'a zeby zmieniac
        placeholder: 'Wartość planowanych nakładów inwestycyjnych [PLN]...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Planowany termin nabycia gruntu', // Nazwa wyświetlana
        state: this.state.planned_buy_plot, // Jaki state bedzie trzymal dane
        name_state: 'planned_buy_plot', // Nazwa state'a zeby zmieniac
        placeholder: 'Planowany termin nabycia gruntu...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Planowany termin rozpoczęcia realizacji inwestycji', // Nazwa wyświetlana
        state: this.state.start, // Jaki state bedzie trzymal dane
        name_state: 'start', // Nazwa state'a zeby zmieniac
        placeholder: 'Planowany termin rozpoczęcia realizacji inwestycji...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Planowany termin zakończenia inwestycji', // Nazwa wyświetlana
        state: this.state.end, // Jaki state bedzie trzymal dane
        name_state: 'end', // Nazwa state'a zeby zmieniac
        placeholder: 'Planowany termin zakończenia inwestycji...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Liczba zatrudnionych osób w pierwszym roku po rozpoczęciu działalności', // Nazwa wyświetlana
        state: this.state.amount_employees, // Jaki state bedzie trzymal dane
        name_state: 'amount_employees', // Nazwa state'a zeby zmieniac
        placeholder: 'Liczba zatrudnionych osób w pierwszym roku po rozpoczęciu działalności...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label:
          'Czy inwestor jest zainteresowany uzyskaniem zwolnień z podatku dochodowego w związku z planowaną inwestycją?', // Nazwa wyświetlana
        state: this.state.special, // Jaki state bedzie trzymal dane
        name_state: 'special', // Nazwa state'a zeby zmieniac
        placeholder:
          'Czy inwestor jest zainteresowany uzyskaniem zwolnień z podatku dochodowego w związku z planowaną inwestycją...',
        type_input: 1, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: yesOrNo, // Tablica z wyborami,
      },
      {
        label: 'Dodatkowe informacje  (opcjonalnie)', // Nazwa wyświetlana
        state: this.state.additional, // Jaki state bedzie trzymal dane
        name_state: 'additional', // Nazwa state'a zeby zmieniac
        placeholder: 'Dodatkowe informacje...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
    ];

    return (
      <div>
        <br />
        {this.props.serviceInfo.eservice.requiresUserInfo && this.props.serviceInfo.user ? (
          <div>
            <h3 style={{ textAlign: 'center' }}>
              {this.props.serviceInfo.eservice.title}
            </h3>
            <GrayPanel title="Dane inwestora">
              {this.optionsInvestor.map((v, i) => (
                <div key={i} className="row mobile-row container" style={rowStyle}>
                  <div className={labelCol}>
                    <label style={labelStyle} dangerouslySetInnerHTML={{ __html: this.htmlDecode(v.label) }} />
                  </div>
                  <div className={inputCol}>
                    {v.type_input == 0 ? (
                      <input
                        className="form-control"
                        style={this.getStandartInputErrorStyle(v.name_state)}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChange(e, v.name_state)}
                      />
                    ) : null}
                    {v.type_input == 1 ? (
                      <Select
                        clearable={false}
                        options={v.options}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChangeSelect(e, v.name_state)}
                        style={this.getSelectErrorStyle(v.name_state)}
                        onBlur={event => event.preventDefault()}
                        optionClassName="needsclick"
                        blurInputOnSelect={false}
                      />
                    ) : null}
                    {/* RENDER ERROS IN SPAN */}
                    {this.renderErrorsInSpan(v.name_state)}
                  </div>
                </div>
              ))}
              
              {this.state.export == 'Tak' ? (
                <div className="row mobile-row container" style={rowStyle}>
                  <div className={labelCol}>
                    <label style={labelStyle}>Dokąd są eksportowane produkty/usługi</label>
                  </div>
                  <div className={inputCol}>
                    <input
                      className="form-control"
                      style={this.getStandartInputErrorStyle('where_export')}
                      value={this.state.where_export}
                      placeholder="Dokąd są eksportowane produkty/usługi..."
                      onChange={e => this.handleChange(e, 'where_export')}
                    />
                    {/* RENDER ERROS IN SPAN */}
                    {this.renderErrorsInSpan('where_export')}
                  </div>
                </div>
              ) : null}

              {this.state.form_cooperation == 'Inna' ? (
                <div className="row mobile-row container" style={rowStyle}>
                  <div className={labelCol}>
                    <label style={labelStyle}>Inna forma prawna prowadzonej działalności</label>
                  </div>
                  <div className={inputCol}>
                    <input
                      className="form-control"
                      style={this.getStandartInputErrorStyle('form_other')}
                      value={this.state.form_other}
                      placeholder="Podaj prawną formę prowadzonej działalności"
                      onChange={e => this.handleChange(e, 'form_other')}
                    />
                    {/* RENDER ERROS IN SPAN */}
                    {this.renderErrorsInSpan('form_other')}
                  </div>
                </div>
              ) : null}
            </GrayPanel>

            <GrayPanel title="Dane kontaktowe">
              {this.dataContact.map((v, i) => (
                <div key={i} className="row mobile-row container" style={rowStyle}>
                  <div className={labelCol}>
                    <label style={labelStyle} dangerouslySetInnerHTML={{ __html: this.htmlDecode(v.label) }} />
                  </div>
                  <div className={inputCol}>
                    {v.type_input == 0 ? (
                      <input
                        className="form-control"
                        style={this.getStandartInputErrorStyle(v.name_state)}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChange(e, v.name_state)}
                      />
                    ) : null}
                    {v.type_input == 1 ? (
                      <Select
                        clearable={false}
                        options={v.options}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChangeSelect(e, v.name_state)}
                        style={this.getSelectErrorStyle(v.name_state)}
                        onBlur={event => event.preventDefault()}
                        optionClassName="needsclick"
                        blurInputOnSelect={false}
                      />
                    ) : null}
                    {v.type_input == 2 ? (
                      <textarea
                        className="form-control"
                        style={this.getStandartInputErrorStyle(v.name_state)}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChange(e, v.name_state)}
                      />
                    ) : null}
                    {/* RENDER ERROS IN SPAN */}
                    {this.renderErrorsInSpan(v.name_state)}
                  </div>
                </div>
              ))}
            </GrayPanel>

            <GrayPanel title="Planowana inwestycja">
              {this.optionsInvest.map((v, i) => (
                <div key={i} className="row mobile-row container" style={rowStyle}>
                  <div className={labelCol}>
                    <label style={labelStyle} dangerouslySetInnerHTML={{ __html: this.htmlDecode(v.label) }} />
                  </div>
                  <div className={inputCol}>
                    {v.type_input == 0 ? (
                      <input
                        className="form-control"
                        style={this.getStandartInputErrorStyle(v.name_state)}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChange(e, v.name_state)}
                      />
                    ) : null}
                    {v.type_input == 1 ? (
                      <Select
                        clearable={false}
                        options={v.options}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChangeSelect(e, v.name_state)}
                        style={this.getSelectErrorStyle(v.name_state)}
                        onBlur={event => event.preventDefault()}
                        optionClassName="needsclick"
                        blurInputOnSelect={false}
                      />
                    ) : null}
                    {v.type_input == 2 ? (
                      <textarea
                        className="form-control"
                        style={this.getStandartInputErrorStyle(v.name_state)}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChange(e, v.name_state)}
                      />
                    ) : null}
                    {/* RENDER ERROS IN SPAN */}
                    {this.renderErrorsInSpan(v.name_state)}
                  </div>
                </div>
              ))}
              <div className="row mobile-row pull-right">
                <button
                  className="btn btn-primary"
                  style={rowStyle}
                  onClick={() => this.startService()}
                >
                  Wyślij list intencyjny
                </button>
              </div>
              {this.props.serviceInfo.user &&
                this.props.serviceInfo.user.roles &&
                this.props.serviceInfo.user.roles.indexOf('superadmin') > -1 ? (
                  <button onClick={this.insertTestData} className="btn btn-primary">
                    Insert test data
                </button>
                ) : null}
              <EmptyFileDownloader className="btn btn-primary" position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            </GrayPanel>
          </div>
        ) : null}

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
      </div>
    );
  }
}

InvestContact.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.object,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(InvestContact),
);



// WEBPACK FOOTER //
// src/routes/eservices/InvestContact.js